import CardSection from '../sections/CardSection';
import SelectField from '../form/SelectField';
import InputField  from '../form/InputField';

export default function VehicleBasicSection({ 
    data, 
    tiposVehiculos,
    marcas,
    lineas,
    combustibles,
    carrocerias,
    configuraciones,
    onChange, 
    errors 
}) {
    const currentConf = Array.isArray(configuraciones)
        ? configuraciones.find(c => c.codigo === data.configuracion)
        : null;
    const maxPeso = currentConf ? Number(currentConf.peso) : undefined;
    const isConfigSelected = Boolean(data.configuracion);

    const tipoVehiculosOptions = Array.isArray(tiposVehiculos)
        ? tiposVehiculos.map(item => ({
            value: item.codigo,
            label: item.descripcion
        }))
        : [];
    const marcasOptions = Array.isArray(marcas)
        ? marcas.map(item => ({
            value: item.codigo,
            label: item.descripcion
        }))
        : [];
    const lineasOptions = Array.isArray(lineas)
        ? lineas.map(item => ({
            value: item.codigo_linea,
            label: item.descripcion 
        }))
        : [];
    const tipoCombustibleOptions = Array.isArray(combustibles)
        ? combustibles.map(item => ({
            value: item.codigo,
            label: item.descripcion
        }))
        : [];

    const carroceriasOptions = Array.isArray(carrocerias)
        ? carrocerias.map(item => ({
            value: item.codigo,
            label: item.descripcion
        }))
        : [];

    const configuracionesOptions = Array.isArray(configuraciones)
        ? configuraciones.map(item => ({
            value: item.codigo,
            label: item.descripcion
        }))
        : [];

    return (
        <CardSection icon="directions_car" title="Datos básicos del vehículo">
            <div className="row">
                <div className="col-md-4">
                    <InputField
                        id="placa"
                        label="Placa"
                        placeholder="ABC123"
                        uppercase={true}
                        required
                        value={data.placa}
                        onChange={onChange}
                        error={errors.placa}
                    />
                </div>
                <div className="col-md-4">
                    <SelectField
                        id="tipoVehiculo"
                        label="Tipo de Vehículo"
                        options={tipoVehiculosOptions}
                        required
                        value={data.tipoVehiculo}
                        onChange={onChange}
                        error={errors.tipoVehiculo}
                        isSearchable={true}
                    />
                </div>
                <div className="col-md-4">
                    <SelectField
                        id="marca"
                        label="Marca"
                        options={marcasOptions}
                        required
                        value={data.marca}
                        onChange={onChange}
                        error={errors.marca}
                        isSearchable={true}
                    />
                </div>
                <div className="col-md-4">
                    <SelectField
                        id="linea"
                        label="Línea"
                        options={lineasOptions}
                        required
                        value={data.linea}
                        onChange={onChange}
                        error={errors.linea}
                        isSearchable={true}
                    />
                </div>
                <div className="col-md-4">
                    <InputField
                        id="modeloAnio"
                        label="Año"
                        type="number"
                        placeholder="2025"
                        required
                        value={data.modeloAnio}
                        onChange={onChange}
                        error={errors.modeloAnio}
                    />
                </div>
                <div className="col-md-4">
                    <InputField
                        id="color"
                        label="Color"
                        placeholder="Ej. Blanco"
                        required
                        value={data.color}
                        onChange={onChange}
                        error={errors.color}
                    />
                </div>
                <div className="col-md-4">
                    <SelectField
                        id="carroceria"
                        label="Carrocería"
                        options={carroceriasOptions}
                        required
                        value={data.carroceria}
                        onChange={onChange}
                        error={errors.carroceria}
                        isSearchable={true}
                    />
                </div>
                <div className="col-md-4">
                    <InputField
                        id="numeroEjes"
                        label="N° de Ejes"
                        type="number"
                        placeholder="2"
                        required
                        value={data.numeroEjes}
                        onChange={onChange}
                        error={errors.numeroEjes}
                    />
                </div>
                <div className="col-md-4">
                    <SelectField
                        id="tipoCombustible"
                        label="Combustible"
                        options={tipoCombustibleOptions}
                        required
                        value={data.tipoCombustible}
                        onChange={onChange}
                        error={errors.tipoCombustible}
                    />
                </div>
                <div className="col-md-4">
                    <SelectField
                        id="configuracion"
                        label="Configuración del Vehiculo"
                        options={configuracionesOptions}
                        required
                        value={data.configuracion}
                        onChange={onChange}
                        error={errors.configuracion}
                    />
                </div>
                <div className="col-md-4">
                    <InputField
                        id="pesoVacio"
                        label="Peso en vacío (kg)"
                        type="number"
                        placeholder="1234,56"
                        required
                        value={data.pesoVacio}
                        onChange={onChange}
                        min={0}
                        max={maxPeso} 
                        disabled={!isConfigSelected}
                        onInput={e => {
                            if (!isConfigSelected) {
                                e.currentTarget.value = '';
                                return;
                            }
                            const v = Number(e.currentTarget.value);
                            if (maxPeso !== undefined && v > maxPeso) {
                                e.currentTarget.value = String(maxPeso);
                                onChange('pesoVacio', String(maxPeso));
                            }
                        }} 
                        error={errors.pesoVacio}
                    />
                </div>    
                <div className="col-md-4">
                    <InputField
                        id="kilometraje"
                        label="Kilometraje actual del vehículo"
                        type="number"
                        placeholder="50000"
                        required
                        value={data.kilometraje}
                        onChange={onChange}
                        error={errors.kilometraje}
                    />
                </div>       
            </div>
        </CardSection>
    );
}
